import request from "@/utils/request";
const scope = '/api';

// 支付-唤起支付
export function clientPaymentPay(query,token) {
  return request({
    url: scope + "/exueyun-client-consumer/clientPayment/pay",
    method: "post",
    data: query,
    headers: {
        Authorization: token
    }
  });
}
